import OptionsPanel from "./OptionsPanel.js"

export default class EdgeOpacity extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Edge Opacity" // TODO: This needs to be localized
    this.setting = "edgeOpacity"
    this.listOptions = props.labels[this.setting]
    this.select()
  }
  
  static get contextTypes() {
    return super.contextTypes
  }

}
